// extracted by mini-css-extract-plugin
export default {"slider":"contact_slider__3xlbv","slide_track":"contact_slide_track__NOmBQ","scroll":"contact_scroll__jtx+-","slide":"contact_slide__QJXBs","number":"contact_number__D4nek"};